import { eMessageTypesWS } from '../utils/enums';
import {
  DefaultMessage,

  LiveEventOpenedMessage,
  EventRemovedMessage,
  EventScoreUpdatedMessage,
  EventStatsUpdatedMessage,

  BetOfferAddedMessage,
  BetOfferRemovedMessage,
  BetOfferOddsAddedMessage,
  BetOfferOddsRemovedMessage,
  BetOfferOddsUpdatedMessage,
  BetOfferStatusUpdatedMessage,

  MatchClockRemovedMessage,
  MatchClockUpdatedMessage
} from './messages';

export class MessageFactory {
  static create(message) {
    switch (message.mt) {
      case eMessageTypesWS.LIVE_EVENT_OPENED:
        return new LiveEventOpenedMessage(message);
      case eMessageTypesWS.EVENT_REMOVED:
        return new EventRemovedMessage(message);
      case eMessageTypesWS.EVENT_SCORE_UPDATED:
        return new EventScoreUpdatedMessage(message);
      case eMessageTypesWS.EVENT_STATS_UPDATED:
        return new EventStatsUpdatedMessage(message);

      case eMessageTypesWS.BET_OFFER_ADDED:
        return new BetOfferAddedMessage(message);
      case eMessageTypesWS.BET_OFFER_REMOVED:
        return new BetOfferRemovedMessage(message);
      case eMessageTypesWS.BET_OFFER_STATUS_UPDATED:
        return new BetOfferStatusUpdatedMessage(message);

      case eMessageTypesWS.BET_OFFER_ODDS_ADDED:
        return new BetOfferOddsAddedMessage(message);
      case eMessageTypesWS.BET_OFFER_ODDS_REMOVED:
        return new BetOfferOddsRemovedMessage(message);
      case eMessageTypesWS.BET_OFFER_ODDS_UPDATED:
        return new BetOfferOddsUpdatedMessage(message);

      case eMessageTypesWS.MATCH_CLOCK_REMOVED:
        return new MatchClockRemovedMessage(message);
      case eMessageTypesWS.MATCH_CLOCK_UPDATED:
        return new MatchClockUpdatedMessage(message);

      default:
        return new DefaultMessage();
    }
  }
}
